module.exports = __webpack_public_path__ + "static/media/mloppx2_200x200.2d72d3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/mloppx2_200x200.png
// module id = 295
// module chunks = 0